import styled from "styled-components";

export const MedicineListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  margin-bottom: 15px;
  padding-bottom: 100px;
`;

export const SelectAllWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  .selectLabel {
    font-size: 14px;
    font-weight: 500;
  }
`;
export const SubHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
export const SearchWrapper = styled.div``;
export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  position: fixed;
  bottom: 0;
  z-index: 1;
  width: 100%;
  margin-left: -20px;
  background: white;
  padding: 0.5em;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 3px 25px 50px rgba(0, 0, 0, 0.05);
  button.submit {
    background: var(--green);
    color: #fff;

    :disabled {
      background-color: #dddddd;
      color: #74797d;
    }
  }
`;
